import CertsSidePanelBodySummary from './CertsSidePanelBodySummary';

export default CertsSidePanelBodySummary;
